import React from "react";

import "../lspDashboard.scss";
import { Link } from "react-router-dom";
import LspLogo from "../../updating/components/LspLogo";
import { useTranslation } from "react-i18next";
import { Skeleton } from "primereact/skeleton";
const LspCompanyInfo = ({ lspInfo, isLoading }) => {
  const { t } = useTranslation();

  return (
    <div className="info-main-conatiner">
      <LspLogo name={!isLoading ? lspInfo?.name : ""} />
      <div className="info-section">
        <div className="lsp-info">
          <p className="lsp-label">{t("LSP.LOCAL_SERVICE_PARTNER")}</p>
          {isLoading ? (
            <Skeleton height="20px" className="lsp-name" />
          ) : (
            <h2 className="lsp-name">{lspInfo?.name}</h2>
          )}
        </div>
        <div className="info-btn-container">
          <Link to={`/lsp/${lspInfo?.id}/info`}>
            <button className="info-btn" type="button">
              <span>{t("LSP.VIEW_GENERAL_INFORMATION")}</span>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LspCompanyInfo;
